import { sleep } from '@flowus/common/async';
import { message } from '@flowus/common/components/message';
import { useOpenModal } from '@flowus/common/next-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useCallback } from 'react';
import { request } from 'src/common/request/request';

export const useRestoreRole = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();

  return useCallback(
    (pageId: string) => {
      openModal.warning({
        title: t('hooks.restore_role.confirm_title'),
        content: (
          <div className="text-left text-t2 space-y-2">
            <p>{t('hooks.restore_role.restore_data_tip')}</p>
            <p>{t('hooks.restore_role.location_may_change')}</p>
          </div>
        ),
        confirmText: t('common.confirm'),
        confirm: async () => {
          await request.editor.resetPagePermission(pageId);
          message.success(t('hooks.restore_role.success'));
          await sleep(1000);
          location.reload();
        },
      });
    },
    [openModal, t]
  );
};
